export const SET_TOKEN_RECAPTCHA = "RESPONDER_EXIGENCIA_SET_TOKEN_RECAPTCHA";
export const SET_HEADER_EXIGENCIA = "RESPONDER_EXIGENCIA_SET_HEADER_EXIGENCIA";
export const VALIDA_ANALISE_EXIGENCIA = "RESPONDER_EXIGENCIA_VALIDA_ANALISE_EXIGENCIA";
export const TOGGLE_MODAL_DOCUMENTO = "RESPONDER_EXIGENCIA_TOGGLE_MODAL_DOCUMENTO";
export const TOGGLE_MODAL_EXIGENCIA = "RESPONDER_EXIGENCIA_TOGGLE_MODAL_EXIGENCIA";
export const SET_SHOW_GRID_EXIGENCIA = "RESPONDER_EXIGENCIA_SET_SHOW_GRID_EXIGENCIA";
export const SET_DATA_GRID_EXIGENCIA = "RESPONDER_EXIGENCIA_SET_DATA_GRID_EXIGENCIA";
export const SET_FORM_EXIGENCIA = "RESPONDER_EXIGENCIA_SET_FORM_EXIGENCIA";
export const VALIDA_UPLOAD_DOCUMENTO_EXIGENCIA = "RESPONDER_EXIGENCIA_VALIDA_UPLOAD_DOCUMENTO_EXIGENCIA";
export const REMOVER_DOCUMENTO_EXIGENCIA = "RESPONDER_EXIGENCIA_REMOVER_DOCUMENTO_EXIGENCIA";
export const POST_RESPOSTA_EXIGENCIA = "RESPONDER_EXIGENCIA_POST_RESPOSTA_EXIGENCIA";
export const RESET_FORM = "RESPONDER_EXIGENCIA_RESET_FORM";
export const SET_MODAL_EXIGENCIA = "RESPONDER_EXIGENCIA_SET_MODAL_EXIGENCIA";
